<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('global.namefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.number"
            :error-messages="numberErrors"
            :label="$t('global.number')"
            @input="$v.item.number.$touch()"
            @blur="$v.item.number.$touch()"            
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="typeSelectItems"
            v-model="item.types"
            :items="typeSelectItems"
            :error-messages="typesErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('global.type')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.description"
            :error-messages="descriptionErrors"
            :label="$t('global.description')"
            required
            @input="$v.item.description.$touch()"
            @blur="$v.item.description.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.descriptionfr"
            :error-messages="descriptionfrErrors"
            :label="$t('global.descriptionfr')"
            required
            @input="$v.item.descriptionfr.$touch()"
            @blur="$v.item.descriptionfr.$touch()"
          />

        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('global.enabled') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.enabled"
                :error-messages="enabledErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('global.hub') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.public"
                :error-messages="publicErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">

          <v-select
            v-model="item.intensity"
            :items="intensities"
            item-text="text"
            item-value="value"
            :error-messages="intensityErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            :label="$t('process.intensity')"
            variant="underlined"
            required
            color="primary"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.time"
            :error-messages="timeErrors"
            :label="$t('process.time')"
            required
            @input="$v.item.time.$touch()"
            @blur="$v.item.time.$touch()"
          />
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <h4 class="primary--text">{{ $t('process.linkproductcustomer') }}</h4>
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="machineSelectItems"
            v-model="item.machine"
            :items="machineSelectItems"
            :error-messages="machineErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.machine.machine')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="controlUnitSelectItems"
            v-model="item.controlUnit"
            :items="controlUnitSelectItems"
            :error-messages="controlUnitErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.controlunit.controlunit')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="industrialComputerSelectItems"
            v-model="item.industrialComputer"
            :items="industrialComputerSelectItems"
            :error-messages="industrialComputerErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.industrialcomputer.industrialcomputer')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="operatingSystemSelectItems"
            v-model="item.operatingSystem"
            :items="operatingSystemSelectItems"
            :error-messages="operatingSystemErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.operatingsystem.operatingsystem')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareVersionSelectItems"
            v-model="item.softwareVersion"
            :items="softwareVersionSelectItems"
            :error-messages="softwareVersionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.software.software')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialSupplySelectItems"
            v-model="item.materialSupply"
            :items="materialSupplySelectItems"
            :error-messages="materialSupplyErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('qualitycheck.product.materialsupply')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="toolHeadSelectItems"
            v-model="item.toolHead"
            :items="toolHeadSelectItems"
            :error-messages="toolHeadErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.tool.toolhead')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="optionSelectItems"
            v-model="item.optionMachine"
            :items="optionSelectItems"
            :error-messages="optionMachineErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.option.option')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="accessorySelectItems"
            v-model="item.accessory"
            :items="accessorySelectItems"
            :error-messages="accessoryErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('profile.accessory.accessory')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="customerSelectItems"
            v-model="item.customers"
            :items="customerSelectItems"
            :error-messages="customersErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('qualitycheck.customer.customers')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <h4 class="primary--text">{{ $t('process.defaultprocessmachine') }}</h4>
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('process.defaultprocess') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.defaultProcess"
                :error-messages="defaultProcessErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="categorySelectItems"
            v-model="item.category"
            :items="categorySelectItems"
            :error-messages="categoryErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('process.category')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.fixtureRef"
            :error-messages="fixtureRefErrors"
            :label="$t('process.fixtureRef')"
            required
            @input="$v.item.fixtureRef.$touch()"
            @blur="$v.item.fixtureRef.$touch()"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'ProcessForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {

      this.typeGetSelectItems();
      this.customerGetSelectItems();

      this.controlUnitGetSelectItems();
      this.machineGetSelectItems();
      this.industrialComputerGetSelectItems();
      this.operatingSystemGetSelectItems();
      this.softwareVersionGetSelectItems();
      this.materialSupplyGetSelectItems();
      this.toolHeadGetSelectItems();
      this.optionGetSelectItems();
      this.accessoryGetSelectItems();
      this.categoryGetSelectItems();
  },

  data() {
    return {
        name: null,
        namefr: null,
        number: null,
        description: null,
        descriptionfr: null,
        enabled: null,
        defaultProcess: null,
        public: null,
        types: null,
        customers: null,
        controlUnit: null,
        machine: null,
        intensity: null,
        time: null,
        industrialComputer: null,
        operatingSystem: null,
        softwareVersion: null,
        materialSupply: null,
        toolHead: null,
        optionMachine: null,
        accessory: null,
        category: null,
        fixtureRef: null,
        intensities: [
          { value: 1, text: this.$t('global.easy') },
          { value: 2, text: this.$t('global.normal') },
          { value: 3, text: this.$t('global.hard') },
        ],
        
    };
  },
  computed: {
    isLoading() {
      return (
        this.isLoading_type ||
        this.isLoading_customer ||
        this.isLoading_controlUnit ||
        this.isLoading_machine ||
        this.isLoading_industrialComputer ||
        this.isLoading_operatingSystem ||
        this.isLoading_softwareVersion ||
        this.isLoading_materialSupply ||
        this.isLoading_toolHead ||
        this.isLoading_option ||
        this.isLoading_accessory ||
        this.isLoading_category
       );
    },
    ...mapFields('processtype', {
      typeSelectItems: 'selectItems',
      isLoading_type : 'isLoading'
    }),
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
      isLoading_customer : 'isLoading'
    }),
    ...mapFields('controlunit', {
      controlUnitSelectItems: 'selectItems',
      isLoading_controlUnit : 'isLoading'
    }),
    ...mapFields('machine', {
      machineSelectItems: 'selectItems',
      isLoading_machine : 'isLoading'
    }),
    ...mapFields('industrialcomputer', {
      industrialComputerSelectItems: 'selectItems',
      isLoading_industrialComputer : 'isLoading'
    }),
    ...mapFields('operatingsystem', {
      operatingSystemSelectItems: 'selectItems',
      isLoading_operatingSystem : 'isLoading'
    }),
    ...mapFields('softwareversion', {
      softwareVersionSelectItems: 'selectItems',
      isLoading_softwareVersion : 'isLoading'
    }),
    ...mapFields('materialsupply', {
      materialSupplySelectItems: 'selectItems',
      isLoading_materialSupply : 'isLoading'
    }),
    ...mapFields('toolhead', {
      toolHeadSelectItems: 'selectItems',
      isLoading_toolHead : 'isLoading'
    }),
    ...mapFields('option', {
      optionSelectItems: 'selectItems',
      isLoading_option : 'isLoading'
    }),
    ...mapFields('accessory', {
      accessorySelectItems: 'selectItems',
      isLoading_accessory : 'isLoading'
    }),
    ...mapFields('category', {
      categorySelectItems: 'selectItems',
      isLoading_category : 'isLoading'
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.item.name.$dirty) return errors;
      has(this.violations, 'name') && errors.push(this.violations.name);
      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    namefrErrors() {
      const errors = [];
      if (!this.$v.item.namefr.$dirty) return errors;
      has(this.violations, 'namefr') && errors.push(this.violations.namefr);
      !this.$v.item.namefr.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    numberErrors() {
      const errors = [];
      if (!this.$v.item.number.$dirty) return errors;
      has(this.violations, 'number') && errors.push(this.violations.number);
      !this.$v.item.number.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    intensityErrors() {
      const errors = [];
      if (!this.$v.item.intensity.$dirty) return errors;
      has(this.violations, 'intensity') && errors.push(this.violations.intensity);
      !this.$v.item.intensity.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    timeErrors() {
      const errors = [];
      if (!this.$v.item.time.$dirty) return errors;
      has(this.violations, 'time') && errors.push(this.violations.time);
      !this.$v.item.time.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    
    descriptionErrors() {
      const errors = [];
      if (!this.$v.item.description.$dirty) return errors;
      has(this.violations, 'description') && errors.push(this.violations.description);
      !this.$v.item.description.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    descriptionfrErrors() {
      const errors = [];
      if (!this.$v.item.descriptionfr.$dirty) return errors;
      has(this.violations, 'descriptionfr') && errors.push(this.violations.descriptionfr);
      !this.$v.item.descriptionfr.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    defaultProcessErrors() {
      const errors = [];
      if (!this.$v.item.defaultProcess.$dirty) return errors;
      has(this.violations, 'defaultProcess') && errors.push(this.violations.defaultProcess);
      return errors;
    },
    enabledErrors() {
      const errors = [];
      if (!this.$v.item.enabled.$dirty) return errors;
      has(this.violations, 'enabled') && errors.push(this.violations.enabled);
      return errors;
    },
    publicErrors() {
      const errors = [];
      if (!this.$v.item.public.$dirty) return errors;
      has(this.violations, 'public') && errors.push(this.violations.public);
      return errors;
    },
    typesErrors() {
      const errors = [];
      if (!this.$v.item.types.$dirty) return errors;
      has(this.violations, 'types') && errors.push(this.violations.types);
      !this.$v.item.types.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    customersErrors() {
      const errors = [];
      if (!this.$v.item.customers.$dirty) return errors;
      has(this.violations, 'customers') && errors.push(this.violations.customers);
      return errors;
    },
    controlUnitErrors() {
      const errors = [];
      if (!this.$v.item.controlUnit.$dirty) return errors;
      has(this.violations, 'controlUnit') && errors.push(this.violations.controlUnit);
      return errors;
    },
    machineErrors() {
      const errors = [];
      if (!this.$v.item.machine.$dirty) return errors;
      has(this.violations, 'machine') && errors.push(this.violations.machine);
      return errors;
    },
    industrialComputerErrors() {
      const errors = [];
      if (!this.$v.item.industrialComputer.$dirty) return errors;
      has(this.violations, 'industrialComputer') && errors.push(this.violations.industrialComputer);
      return errors;
    },
    operatingSystemErrors() {
      const errors = [];
      if (!this.$v.item.operatingSystem.$dirty) return errors;
      has(this.violations, 'operatingSystem') && errors.push(this.violations.operatingSystem);
      return errors;
    },
    softwareVersionErrors() {
      const errors = [];
      if (!this.$v.item.softwareVersion.$dirty) return errors;
      has(this.violations, 'softwareVersion') && errors.push(this.violations.softwareVersion);
      return errors;
    },
    materialSupplyErrors() {
      const errors = [];
      if (!this.$v.item.materialSupply.$dirty) return errors;
      has(this.violations, 'materialSupply') && errors.push(this.violations.materialSupply);
      return errors;
    },
    toolHeadErrors() {
      const errors = [];
      if (!this.$v.item.toolHead.$dirty) return errors;
      has(this.violations, 'toolHead') && errors.push(this.violations.toolHead);
      return errors;
    },
    optionMachineErrors() {
      const errors = [];
      if (!this.$v.item.optionMachine.$dirty) return errors;
      has(this.violations, 'optionMachine') && errors.push(this.violations.optionMachine);
      return errors;
    },
    accessoryErrors() {
      const errors = [];
      if (!this.$v.item.accessory.$dirty) return errors;
      has(this.violations, 'accessory') && errors.push(this.violations.accessory);
      return errors;
    },
    categoryErrors() {
      const errors = [];
      if (!this.$v.item.category.$dirty) return errors;
      has(this.violations, 'category') && errors.push(this.violations.category);
      return errors;
    },
    fixtureRefErrors() {
      const errors = [];
      if (!this.$v.item.fixtureRef.$dirty) return errors;
      has(this.violations, 'fixtureRef') && errors.push(this.violations.fixtureRef);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
      typeGetSelectItems: 'processtype/fetchSelectItems'
    }),
    ...mapActions({
      customerGetSelectItems: 'customer/fetchSelectItems'
    }),
    ...mapActions({
      controlUnitGetSelectItems: 'controlunit/fetchSelectItems'
    }),
    ...mapActions({
      machineGetSelectItems: 'machine/fetchSelectItems'
    }),
    ...mapActions({
      industrialComputerGetSelectItems: 'industrialcomputer/fetchSelectItems'
    }),
    ...mapActions({
      operatingSystemGetSelectItems: 'operatingsystem/fetchSelectItems'
    }),
    ...mapActions({
      softwareVersionGetSelectItems: 'softwareversion/fetchSelectItems'
    }),
    ...mapActions({
      materialSupplyGetSelectItems: 'materialsupply/fetchSelectItems'
    }),
    ...mapActions({
      toolHeadGetSelectItems: 'toolhead/fetchSelectItems'
    }),
    ...mapActions({
      optionGetSelectItems: 'option/fetchSelectItems'
    }),
    ...mapActions({
      accessoryGetSelectItems: 'accessory/fetchSelectItems'
    }),
    ...mapActions({
      categoryGetSelectItems: 'category/fetchSelectItems'
    }),

  },
  validations: {
    item: {
      name: {
        required,
      },
      namefr: {
        required,
      },
      description: {
        required,
      },
      descriptionfr: {
        required,
      },
      number: {
        required,
      },
      intensity: {
        required,
      },
      time: {
        required,
      },
      enabled: {
      },
      defaultProcess: {
      },
      public: {
      },
      types: {
        required,
      },
      customers: {
      },
      controlUnit: {
      },
      machine: {
      },
      industrialComputer: {
      },
      operatingSystem: {
      },
      softwareVersion: {
      },
      materialSupply: {
      },
      toolHead: {
      },
      optionMachine: {
      },
      accessory: {
      },
      category: {
      },
      fixtureRef: {
      },
    }
  }
};
</script>
